export default "__VITE_ASSET__DnpD5xsE__"